import { Link } from "react-router-dom";

// Import category images
import Category11 from "../../assets/img/Category1.jpg";
import Category22 from "../../assets/img/Category2.jpg";
import Category33 from "../../assets/img/Category3.jpg";
import Category44 from "../../assets/img/Category4.jpg";
import Category55 from "../../assets/img/Category5.jpg";

import Category1 from "../../assets/img/Category1.png";
import Category2 from "../../assets/img/Category2.png";
import Category3 from "../../assets/img/Category3.png";
import Category4 from "../../assets/img/Category4.png";
import Category5 from "../../assets/img/Category5.png";

const categoryList = [
  { name: "Snacks", img: Category1 },
  { name: "Fish", img: Category2 },
  { name: "Paratha", img: Category3 },
  { name: "Vegetables", img: Category4 },
  { name: "Bakery & Sweets", img: Category5 },
];
const categoryList2 = [
  { name: "Snacks", img: Category11 },
  { name: "Fish", img: Category22 },
  { name: "Paratha", img: Category33 },
  { name: "Vegetables", img: Category44 },
  { name: "Bakery & Sweets", img: Category55 },
];

const CategoryGrid = () => {
  return (
    <div>
      {/* <div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
        <div className="flex flex-col md:flex-col lg:flex-row items-center justify-center border border-[#FFCD72] rounded-md bg-white p-4">
          <img
            src={categoryList[0].img}
            alt={categoryList[0].name}
            className="h-80 object-contain"
          />
          <div className="text-center text-2xl lg:text-left lg:ml-4">
            <h2 className="font-bold mt-2">{categoryList[0].name}</h2>
            <Link
              to={`/productListView?category=${encodeURIComponent(
                categoryList[0].name
              )}`}
            >
              <button className="btn bg-white border-[#1C3A27] text-[#1C3A27] hover:bg-[#1DA14D] px-4 py-2 font-medium hover:font-bold rounded mt-2">
                view all <i className="fas fa-arrow-right ml-2"></i>
              </button>
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-2 items-center">
          {categoryList.slice(1).map((cat, index) => (
            <div
              key={index}
              className="flex flex-col md:flex-col lg:flex-row items-center justify-center border border-[#FFCD72] rounded-md bg-white p-4"
            >
              <img
                src={cat.img}
                alt={cat.name}
                className="h-40 object-contain"
              />
              <div className="text-center mt-2 lg:ml-4">
                <h2 className="text-sm font-bold">{cat.name}</h2>
                <Link
                  to={`/productListView?category=${encodeURIComponent(
                    cat.name
                  )}`}
                >
                  <button className="flex btn bg-white border-[#1C3A27] text-[#1C3A27] hover:bg-[#1DA14D] px-4 py-2 font-medium hover:font-bold rounded mt-2">
                    view all <i className="fas fa-arrow-right ml-1"></i>
                  </button>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div> */}

      {/* 2nd design */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-2 mt-6">
        {/* First Large Card */}
        <Link
          to={`/productListView?category=${encodeURIComponent(
            categoryList2[0].name
          )}`}
          className="relative group md:row-span-2 h-[360px] md:h-[468px] overflow-hidden rounded-md shadow-md"
        >
          <img
            src={categoryList2[0].img}
            alt={categoryList2[0].name}
            loading="lazy"
            className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
          />
          <div className="absolute inset-0 bg-black/40" />
          <div className="absolute inset-0 flex items-center justify-center">
            <span className="border backdrop-blur-sm lg:text-2xl border-[#C9A86A] px-6 py-2 text-white font-semibold rounded-md group-hover:bg-[#C9A86A] group-hover:text-black transition">
              {categoryList2[0].name}
            </span>
          </div>
        </Link>

        {/* Four Smaller Cards */}
        <div className="grid grid-cols-2 gap-2 items-center">
          {categoryList2.slice(1).map((cat) => (
            <Link
              key={cat.name}
              to={`/productListView?category=${encodeURIComponent(cat.name)}`}
              className="relative group h-[180px] md:h-[230px] overflow-hidden rounded-md shadow-md"
            >
              <img
                src={cat.img}
                alt={cat.name}
                loading="lazy"
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-black/40" />
              <div className="absolute inset-0 flex items-center justify-center">
                <span className="border backdrop-blur-sm lg:text-2xl border-[#C9A86A] px-4 py-1.5 text-white font-medium rounded-md group-hover:bg-[#C9A86A] group-hover:text-black transition">
                  {cat.name}
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CategoryGrid;
